import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { JsonLd } from "../../../StructuredData/JsonLd.js";
import { getServices } from "../../../../utils/utils/get-services.js";
import { getOpeningHoursSpecification } from "../../../../utils/utils/get-opening-hours-specification.js";
const Store = ({ store, url }) => {
  const features = useFeatureToggles();
  const cleanUrl = url.split("?")[0];
  const { rating } = store;
  const payload = {
    "@type": "Store",
    "@id": `${cleanUrl}/${store.town.toLocaleLowerCase()}/${store.slug}#store`,
    url: `${cleanUrl}/${store.town.toLocaleLowerCase()}/${store.slug}`,
    name: store.storeName,
    description: store.metaDescription,
    email: store.storeEmailAddress,
    telephone: store.Phone1,
    image: store.detailImage,
    address: [
      {
        "@type": "PostalAddress",
        streetAddress: `${store.streetName}`,
        postalCode: store.postalCode,
        addressLocality: store.town,
        addressCountry: store.country
      }
    ],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "sales contact point",
      telephone: store.Phone1
    },
    openingHoursSpecification: getOpeningHoursSpecification(store),
    hasOfferCatalog: store.facilities ? getServices(store.facilities) : void 0,
    aggregateRating: features.isStoreRatingsEnabled && rating ? {
      "@type": "AggregateRating",
      bestRating: 5,
      worstRating: 1,
      ratingValue: rating.value,
      ratingCount: rating.count
    } : void 0
  };
  return /* @__PURE__ */ React.createElement(JsonLd, { ...payload });
};
export {
  Store
};
//# sourceMappingURL=Store.sd.js.map
